import Card from "components/card";
import { Rating } from "@aws-amplify/ui-react";
import { useDealData } from "contexts/DealContext";
import { usePortfolioData } from "contexts/PortfolioContext";
import { useViewMode } from "contexts/ViewModeContext";
import "../../../assets/css/App.css";

const BuildingRatings = () => {
    const { viewMode } = useViewMode();

    // Deal data
    const { currentFacility: dealFacility } = useDealData();

    // Portfolio data
    const { currentPortfolioFacility } = usePortfolioData();

    // Use appropriate data based on view mode
    const currentFacility = viewMode === 'portfolio' ? currentPortfolioFacility : dealFacility;

    const details = currentFacility?.details || {};

    const facilityRating = details["Star Rating"] || 0;
    const healthInspection = details["Health Inspection Star Rating"] || 0;
    const staffing = details["Staffing Star Rating"] || 0;

    // Find quality rating among the detail keys
    const quality = Object.keys(details).reduce((acc, key) => {
        if (key.toLowerCase().includes("quality")) {
            acc = details[key];
        }
        return acc;
    }, 0);

    return (
        <Card extra={"justify-around w-full p-[16px] bg-cover gap-1 flex flex-col"}>
            <h3 className="ml-6 mb-2 text-xl self-start font-bold text-gray-700 dark:text-white">
                Facility Ratings
            </h3>
            <div className="flex flex-col items-start justify-start pt-2 pl-4 md:pl-1">
                <Rating value={facilityRating} fillColor="#f0b41c" />
                <p className="mt-1 text-sm text-gray-700">Overall Rating</p>
            </div>
            <div className="flex flex-col items-start justify-start pt-2 pl-4 md:pl-1">
                <Rating value={healthInspection} fillColor="#f0b41c" />
                <p className="mt-1 text-sm text-gray-700">Health Inspection</p>
            </div>
            <div className="flex flex-col items-start justify-start pt-2 pl-4 md:pl-1">
                <Rating value={staffing} fillColor="#f0b41c" />
                <p className="mt-1 text-sm text-gray-700">Staffing</p>
            </div>
            <div className="flex flex-col items-start justify-start pt-2 pl-4 md:pl-1">
                <Rating value={quality} fillColor="#f0b41c" />
                <p className="mt-1 text-sm text-gray-700">Quality</p>
            </div>
        </Card>
    );
};

export default BuildingRatings;